module.exports = __webpack_public_path__ + "static/media/thumbnail.425b8a2d.jpg";